<div class="flex-fill">
    <p>Er kan maximaal 1 toolbox tegelijk getoond worden</p>
    <div class="row">
        <div class="col-12">
            <mat-form-field class="w-100">
                <input [formControl]="form.controls.name" matInput placeholder="Naam" />
                <mat-error [control]="form.controls.name"></mat-error>
            </mat-form-field>
        </div>
        <div class="col-12">
            <mat-form-field class="w-100">
                <input
                    [min]="form.value.begindate"
                    [max]="form.value.enddate"
                    [matDatepicker]="pickerBefore"
                    [formControl]="form.controls.view_before"
                    (focus)="pickerBefore.open()"
                    matInput
                    placeholder="Uiterste datum verplicht lezen" />
                <mat-datepicker-toggle [for]="pickerBefore" matSuffix></mat-datepicker-toggle>
                <mat-datepicker #pickerBefore></mat-datepicker>
                <mat-error [control]="form.controls.view_before"></mat-error>
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <mat-form-field class="w-100">
                <input
                    [min]="minDate"
                    [matDatepicker]="pickerStart"
                    [formControl]="form.controls.begindate"
                    (focus)="pickerStart.open()"
                    matInput
                    placeholder="Zichtbaar vanaf" />
                <mat-datepicker-toggle [for]="pickerStart" matSuffix></mat-datepicker-toggle>
                <mat-datepicker #pickerStart></mat-datepicker>
                <mat-error [control]="form.controls.begindate"></mat-error>
            </mat-form-field>
        </div>
        <div class="col-12">
            <mat-form-field class="w-100">
                <input
                    [min]="form.value.begindate"
                    [matDatepicker]="pickerEnd"
                    [formControl]="form.controls.enddate"
                    (focus)="pickerEnd.open()"
                    matInput
                    placeholder="Zichtbaar tot" />
                <mat-datepicker-toggle [for]="pickerEnd" matSuffix></mat-datepicker-toggle>
                <mat-datepicker #pickerEnd></mat-datepicker>
                <mat-error [control]="form.controls.enddate"></mat-error>
            </mat-form-field>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col-auto">
            <app-codalt-upload-file [fcFile]="form.controls.pdf"></app-codalt-upload-file>
            @if (form.controls.pdf?.touched) {
                <mat-error [control]="form.controls.pdf"></mat-error>
            }
        </div>
        @if (form.value.pdf && form.value.id) {
            <div class="col">
                <button (click)="showToolbox()" mat-raised-button color="accent">Toon toolbox</button>
            </div>
        }
    </div>
</div>
<div class="row justify-content-center pt-5">
    <div class="col-24">
        <div class="d-flex">
            <button (click)="back.emit()" mat-raised-button>Terug</button>
            <div class="spacer"></div>
            <button id="btn-save" [disabled]="saving" (click)="save()" color="primary" mat-raised-button>
                Opslaan
                @if (saving) {
                    <i class="fas fa-circle-notch fa-spin"></i>
                }
            </button>
        </div>
    </div>
</div>
<div class="my-3">
    <mat-accordion class="w-100" multi>
        @if (questions?.length > 0) {
            <mat-expansion-panel class="mb-3">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <mat-icon class="me-2" color="primary">bar_chart</mat-icon>
                        Statistieken
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <app-toolbox-quiz-stats [toolboxId]="toolbox.id"></app-toolbox-quiz-stats>
            </mat-expansion-panel>
        }
        @if (toolbox?.id > 0) {
            <mat-expansion-panel class="mb-3">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <mat-icon class="me-2" color="accent">edit</mat-icon>
                        Vragen beheren
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <app-toolbox-question-form #questionForm [toolboxId]="toolbox.id"></app-toolbox-question-form>
            </mat-expansion-panel>
        }
    </mat-accordion>
</div>
